import React from 'react';
import PropTypes from 'prop-types';
import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Cell,
} from 'recharts';
import { chartTheme } from './chartTheme';

const PieChartOverall = ({ data }) => {
  if (!data || !data.sections) return null;

  const totalAbove = data.sections.reduce(
    (sum, item) => sum + item.studentsAboveThreshold,
    0,
  );
  const totalBelow = data.sections.reduce(
    (sum, item) => sum + item.studentsBelowThreshold,
    0,
  );

  const totalStudents = totalAbove + totalBelow || 1;

  const percentAbove = ((totalAbove / totalStudents) * 100).toFixed(1);
  const percentBelow = ((totalBelow / totalStudents) * 100).toFixed(1);

  const numericPercentage = data.numericPercentage;

  const pieData = [
    {
      name: `Students Below ${numericPercentage}%`,
      value: totalBelow,
      color: chartTheme.secondary,
    },
    {
      name: `Students Above ${numericPercentage}%`,
      value: totalAbove,
      color: chartTheme.main,
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '400px',
      }}
    >
      <h3>Overall Student Performance Distribution</h3>

      <p
        style={{
          fontSize: '14px',
          color: 'gray',
          textAlign: 'center',
          maxWidth: '80%',
          marginBottom: '10px',
        }}
      >
        This chart shows the overall distribution of students based on their
        performance.{' '}
        <b>
          {percentBelow}% of students scored below {numericPercentage}%
        </b>
        , while
        <b>
          {' '}
          {percentAbove}% performed above {numericPercentage}%.
        </b>
      </p>

      <ResponsiveContainer width="50%" height={300}>
        <PieChart>
          <Tooltip formatter={(value) => `${value} students`} />
          <Legend wrapperStyle={{ fontSize: '14px', marginBottom: '10px' }} />
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            width={400}
            height={250}
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartOverall;

PieChartOverall.propTypes = {
  data: PropTypes.shape({
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        studentsAboveThreshold: PropTypes.number,
        studentsBelowThreshold: PropTypes.number,
      }),
    ),
    numericPercentage: PropTypes.number,
  }).isRequired,
};
